"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearOnboardingRejectionCommand = void 0;
const cq_core_1 = require("@leavy/cq-core");
const base_1 = require("../../base");
const BaseOnboardingCommand_1 = require("./BaseOnboardingCommand");
let ClearOnboardingRejectionCommand = class ClearOnboardingRejectionCommand extends BaseOnboardingCommand_1.BaseOnboardingCommand {
};
ClearOnboardingRejectionCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "clear_onboarding_rejection",
    })
], ClearOnboardingRejectionCommand);
exports.ClearOnboardingRejectionCommand = ClearOnboardingRejectionCommand;
//# sourceMappingURL=ClearOnboardingRejectionCommand.js.map